<sms-dialog
  [title]="data.title"
  [size]="'sm'"
  [danger]="!!data.danger"
  (close)="onCancel()">

  <div body class="sms-confirm-body">
    <div class="sms-confirm-icon" [class.sms-confirm-icon-danger]="data.danger">
      <i class="bi" [class.bi-exclamation-triangle-fill]="data.danger" [class.bi-question-circle-fill]="!data.danger"></i>
    </div>
    <div class="sms-confirm-text">
      <p class="sms-confirm-message">{{ data.message }}</p>
      <p *ngIf="data.details" class="sms-confirm-details">{{ data.details }}</p>
      <details *ngIf="data.items?.length" class="sms-confirm-records">
        <summary>{{ data.items?.length }} {{ data.itemsLabel || 'records' }} — View list</summary>
        <ul tabindex="0" aria-label="Affected records">
          <li *ngFor="let item of data.items">
            <span>{{ item.label }}</span>
            <small *ngIf="item.detail">{{ item.detail }}</small>
          </li>
        </ul>
      </details>
    </div>
  </div>

  <ng-container footer>
    <button type="button" class="secondary-btn" (click)="onCancel()">{{ data.cancelText }}</button>
    <button type="button"
            class="primary-button"
            [class.sms-btn-danger]="data.danger"
            (click)="onConfirm()">
      {{ data.confirmText }}
    </button>
  </ng-container>
</sms-dialog>
